import i, { css as t } from "styled-components";
import { Button as n } from "../../Inputs/Button/Button.es.js";
const a = {
  success: "var(--color-success-strong)",
  warning: "var(--color-warning-strong)",
  error: "var(--color-error-default)",
  info: "var(--color-info-strong)"
}, e = {
  success: "var(--color-success-weakest)",
  warning: "var(--color-warning-weakest)",
  error: "var(--color-error-weakest)",
  info: "var(--color-info-weakest)"
}, d = i.div.withConfig({
  displayName: "Notification",
  componentId: "sc-zzb8gg-0"
})(["border-radius:var(--size-border-radius-md);display:flex;gap:8px;padding:8px;text-align:left;width:", ";", ""], ({
  $size: o
}) => o || "100%", ({
  $status: o
}) => t(["background-color:", ";border:1px solid ", ";border-left-width:0.4rem;"], e[o], a[o]));
var r;
const g = i.div.withConfig({
  displayName: "NotificationBody",
  componentId: "sc-zzb8gg-1"
})(["flex-grow:1;padding-top:1px;", "{margin-top:2px;}"], (r = n.S) == null ? void 0 : r.Button);
export {
  d as Notification,
  g as NotificationBody
};
//# sourceMappingURL=style.es.js.map
